import React from 'react';
import { createRoot } from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import App from './App';
import { GlobalStyles } from './AppStyledComponents';
import './fonts/_fontFactorA.scss'

const container = document.getElementById('root');

if (container) {
  const root = createRoot(container);
  root.render(
    <>
      <GlobalStyles />
      <App />
    </>
  );
}

// Si deseas comenzar a medir el rendimiento en tu aplicación, pasa una función
// para registrar los resultados (por ejemplo: reportWebVitals(console.log))
// o envíalos a un endpoint de análisis. Aprende más: https://bit.ly/CRA-vitals
reportWebVitals();